export const CATEGORIES = [
  // Order matters — this is how they render in the composer chip row.
  { id: "CHILL",          label: "Chill",          color: "#7B61FF" }, // violet
  { id: "SOCIAL",         label: "Social",         color: "#FFB800" }, // amber
  { id: "ADVENTUROUS",    label: "Adventurous",    color: "#FF6B00" }, // neon orange
  { id: "FLIRTY",         label: "Mingle",         color: "#EC4899" }, // hot pink
  { id: "NETWORKING",     label: "Networking",     color: "#3B82F6" }, // blue
  { id: "LOCAL_BUSINESS", label: "Local Business", color: "#00C46A" }, // green
];

// Short conversational hint shown the FIRST time a user taps each category.
// Persisted per-user in localStorage (bl_cat_seen_<ID>).
export const CATEGORY_HINTS = {
  CHILL:          "Just here to vibe and join the conversation.",
  SOCIAL:         "Open to meeting new people and making new friends.",
  ADVENTUROUS:    "Looking to link up and do something in real time.",
  FLIRTY:         "Open to mingling — meeting new people, sparking chemistry, or seeing where things go.",
  NETWORKING:     "Looking to connect with people for business, work, or new opportunities.",
  LOCAL_BUSINESS: "Promote your business, service, event, or something happening nearby.",
};

export function feet(m) { return m == null ? null : Math.round(m * 3.28084); }

export function timeAgo(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const s = Math.floor((Date.now() - d.getTime()) / 1000);
  if (s < 60) return `${s}S AGO`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}M AGO`;
  const h = Math.floor(m / 60);
  return `${h}H AGO`;
}

export function fmtRemaining(s) {
  if (s == null) return null;
  if (s <= 0) return "0M";
  const m = Math.floor(s / 60);
  if (m >= 60) return `${Math.floor(m / 60)}H`;
  if (m >= 1) return `${m}M`;
  return `${s}S`;
}
